<template>
  <span>
    +
  </span>
</template>
